module.exports = __webpack_public_path__ + "media/images/tailwind/footer-bg-f198da9980e5e1a77e015d2c71637cd2.png";